import React, { useEffect, useState } from 'react';
import './Footer.css';
import facebookIcon from '../assets/svg/fa-facebook.svg';
import instagramIcon from '../assets/svg/fa-instagram.svg';
import tiktokIcon from '../assets/svg/fa-tiktok.svg';
import youtubeIcon from '../assets/svg/fa-youtube.svg';

const BASE = "https://beszeljegyesulet.hu/wp/wp-json/wp/v2";

const Footer = () => {
  const [tudasPosts, setTudasPosts] = useState([]);

  useEffect(() => {
    fetch(`${BASE}/categories?per_page=100`)
      .then((r) => r.json())
      .then((cats) => {
        const cat = cats.find(
          (c) => c.name === "Tudástár" || c.slug === "tudastar"
        );
        if (!cat) return [];
        return fetch(`${BASE}/posts?categories=${cat.id}&per_page=5&order=asc&orderby=date`).then((r) => r.json());
      })
      .then((data) => {
        if (Array.isArray(data)) setTudasPosts(data);
      })
      .catch((err) => console.error("Footer fetch error:", err));
  }, []);

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-card">
          <div className="footer-columns">
            <div className="footer-column">
              <img src={require('./assets/beszELJ_logo2.png')} alt="Logo" className="footer-logo" />
              <a href="/about" className="footer-left-link">Rólunk</a>
              <a href="/events" className="footer-left-link">Események</a>
              <a href="/stuttering" className="footer-left-link">Dadogás</a>
              <a href="/faq" className="footer-left-link">Kérdések</a>
              <a href="mailto:beszeljegyesulet@gmail.com" className="footer-left-link">Kapcsolat</a>
            </div>

            <div className="footer-column">
              <p className="footer-title">Tudástár</p>
              {tudasPosts.length > 0
                ? tudasPosts.map((post) => (
                    <a
                      key={post.id}
                      className="footer-link"
                      href={`/posts/${post.slug}`}
                      dangerouslySetInnerHTML={{ __html: post.title.rendered }}
                    />
                  ))
                : (
                    <>
                      <a className="footer-link" href="#">Mi a dadogás?</a>
                      <a className="footer-link" href="#">Gyakori tévhitek és igazságok</a>
                      <a className="footer-link" href="#">Tippek a kommunikációhoz</a>
                      <a className="footer-link" href="#">Tanácsok szülőknek és tanároknak</a>
                      <a className="footer-link" href="#">Hasznos kutatási források</a>
                    </>
                  )
              }
            </div>

            <div className="footer-column">
              <p className="footer-title">Támogass minket</p>
              <a className="footer-link" href="/membership">Tagság</a>
              <a className="footer-link" href="/support">Adományozz</a>
              <a className="footer-link" href="/support">Legyél önkéntes</a>
              <a className="footer-link" href="/support">Partnerként támogass</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>Copyright © 2026 BeszÉLJ</p>
          <div className="footer-bottom-right">
            <p className="footer-placeholder">Kövess minket!</p>
            <div className="footer-socials">
              <a href="https://www.facebook.com/beszeljegyesulet"><img src={facebookIcon} alt="Facebook" /></a>
              <a href="https://www.instagram.com/beszeljegyesulet"><img src={instagramIcon} alt="Instagram" /></a>
              <a href="https://www.tiktok.com/@beszeljegyesulet"><img src={tiktokIcon} alt="TikTok" /></a>
              <a href="https://www.youtube.com/@beszeljegyesulet"><img src={youtubeIcon} alt="YouTube" /></a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;